<template>
  <rect
    :x="data.x"
    :y="data.y"
    :width="scaleX.bandwidth()"
    :height="height - data.y"
    :style="{fill: color}"
    class="bar"
  >
    <!-- <title>{{ item.displayName }} | {{ item.val }}</title> -->
  </rect>
</template>

<script>
// Component for Rectangles
export default {
  name: 'RectItem',

  props: {
    scaleX: {
      type: Function,
      required: true,
    },
    scaleY: {
      type: Function,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      data: {
        x: this.scaleX(this.item.name),
        y: this.height,
      },
    }
  },
  watch: {
    scaleX () {
      this.updateRect()
    },
  },
  mounted () {
    this.updateRect()
  },
  methods: {
    updateRect () {
      const newVal = {
        x: this.scaleX(this.item.name),
        y: this.scaleY(this.item.val),
      }
      this.data = newVal
    },
  },
}

</script>
